import React from 'react';
import { FadeIn } from './FadeIn';
import { Download, FolderOpen, HeartHandshake } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Download className="w-12 h-12 text-navy" data-id="element-112" />,
    title: 'Paso 1: Descarga',
    desc: 'Descarga la guía y abre tu computadora o tableta en un momento tranquilo.'
  }, {
    icon: <FolderOpen className="w-12 h-12 text-navy" data-id="element-113" />,
    title: 'Paso 2: Organiza',
    desc: 'Sigue el paso a paso visual para crear tus 5 carpetas maestras sin estrés.'
  }, {
    icon: <HeartHandshake className="w-12 h-12 text-navy" data-id="element-114" />,
    title: 'Paso 3: Comparte',
    desc: 'Comparte el acceso con tus seres queridos y disfruta de una paz mental total.'
  }];
  return <section className="bg-white py-20 px-6" data-id="element-115">
      <div className="max-w-5xl mx-auto" data-id="element-116">
        <FadeIn data-id="element-117">
          <h2 className="text-4xl md:text-5xl font-bold text-center text-navy mb-16" data-id="element-118">
            Cómo Funciona
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-119">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-cream -z-10 transform -translate-y-1/2" data-id="element-120"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-121">
              <div className="bg-cream p-8 rounded-2xl text-center shadow-lg border border-gray-100 h-full flex flex-col items-center" data-id="element-122">
                <div className="bg-gold p-5 rounded-full mb-6 text-white shadow-md" data-id="element-123">
                  {step.icon}
                </div>
                <h3 className="text-2xl font-bold text-navy mb-4" data-id="element-124">
                  {step.title}
                </h3>
                <p className="text-lg text-gray-700" data-id="element-125">{step.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn data-id="element-126">
          <div className="text-center pt-12" data-id="element-127">
            <a href="https://dancodigital.com/cart/44413385211987:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-gold hover:bg-yellow-600 text-white font-bold py-4 px-10 rounded-xl shadow-xl transform transition duration-300 hover:-translate-y-1 hover:shadow-2xl text-xl w-full md:w-auto text-center" data-id="element-128">
              ¡Empieza a Organizar Tu Legado Hoy!
            </a>
          </div>
        </FadeIn>
      </div>
    </section>;
}